// Servicio de productos para e-commerce
// Gestión de productos en Supabase

import { supabase } from '../lib/supabase';

/**
 * Obtiene todos los productos activos
 * @returns {Promise<Array>} Lista de productos activos
 */
export const obtenerProductos = async () => {
  try {
    const { data, error } = await supabase
      .from('productos')
      .select('*')
      .eq('activo', true)
      .order('precio', { ascending: true });

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error obteniendo productos:', error);
    throw error;
  }
};

/**
 * Obtiene un producto por ID
 * @param {string} productoId - ID del producto
 * @returns {Promise<Object>} Producto encontrado
 */
export const obtenerProductoPorId = async (productoId) => {
  try {
    const { data, error } = await supabase
      .from('productos')
      .select('*')
      .eq('id', productoId)
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error obteniendo producto:', error);
    throw error;
  }
};

/**
 * Crea un nuevo producto
 * @param {Object} producto - Datos del producto
 * @returns {Promise<Object>} Producto creado
 */
export const crearProducto = async (producto) => {
  try {
    const { data, error } = await supabase
      .from('productos')
      .insert([{
        nombre: producto.nombre,
        precio: producto.precio,
        descripcion: producto.descripcion || null,
        imagen_url: producto.imagen_url || null,
        activo: producto.activo !== undefined ? producto.activo : true
      }])
      .select()
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error creando producto:', error);
    throw error;
  }
};

/**
 * Actualiza un producto existente
 * @param {string} productoId - ID del producto
 * @param {Object} producto - Datos actualizados
 * @returns {Promise<Object>} Producto actualizado
 */
export const actualizarProducto = async (productoId, producto) => {
  try {
    const { data, error } = await supabase
      .from('productos')
      .update({
        nombre: producto.nombre,
        precio: producto.precio,
        descripcion: producto.descripcion,
        imagen_url: producto.imagen_url,
        activo: producto.activo,
        updated_at: new Date().toISOString()
      })
      .eq('id', productoId)
      .select()
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error actualizando producto:', error);
    throw error;
  }
};

/**
 * Elimina un producto (marcado como inactivo)
 * @param {string} productoId - ID del producto
 * @returns {Promise<Object>} Producto actualizado
 */
export const eliminarProducto = async (productoId) => {
  try {
    const { data, error } = await supabase
      .from('productos')
      .update({ activo: false, updated_at: new Date().toISOString() })
      .eq('id', productoId)
      .select()
      .single();

    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Error eliminando producto:', error);
    throw error;
  }
};
